import { Link } from "@circleco/compass/components/Link";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { signOutPath } from "@/react/helpers/urlHelpers";
import type { CurrentUser } from "@/react/types/CurrentUser";

interface ErrorPageFooterV4Props {
  currentUser?: CurrentUser;
}

export const ErrorPageFooterV4 = ({ currentUser }: ErrorPageFooterV4Props) => {
  if (!currentUser) return null;

  return (
    <footer className="bg-secondary border-primary flex min-h-12 items-center justify-center gap-2 border-t px-6 py-4">
      <Typography component="span" variant="body-sm" color="secondary">
        {t("error_page.v4.signed_in_as", {
          email: currentUser.email,
        })}
      </Typography>
      <Link color="branded" href={signOutPath()} size="sm">
        {t("sign_out")}
      </Link>
    </footer>
  );
};
